import {useState} from 'react';

import {useSelectedItemsLocalStorage} from 'hooks/useSelectedItemsLocalStorage';

import {BasketWeightCapacityComponent} from './BasketWeightCapacity.component';
import {ExpressWeightCapacityModal} from './ExpressWeightCapacityModal';
import {StickyContainerWrapper} from './styles';

export const BasketWeightCapacityStickyComponent = () => {
  const [openBasketCapacityModal, setOpenBasketCapacityModal] = useState(false);
  const selectedItemsLocalStorage = useSelectedItemsLocalStorage();
  const selectedItems = selectedItemsLocalStorage.get();
  const toggleModal = () => {
    setOpenBasketCapacityModal((prev) => !prev);
  };
  if (!selectedItems?.length) {
    return null;
  }
  return (
    <StickyContainerWrapper>
      <BasketWeightCapacityComponent onClick={toggleModal} />
      <ExpressWeightCapacityModal open={openBasketCapacityModal} onClose={toggleModal} />
    </StickyContainerWrapper>
  );
};
